export const CLOVER_FIELD_TYPE_TO_FIELD_STATE_NAME = {
  CARD_NUMBER: 'cardNumber',
  CARD_CVV: 'cvv',
  CARD_DATE: 'expirationDate',
  CARD_POSTAL_CODE: 'zip'
};
